module.exports = __webpack_public_path__ + "img/Palestinian Territory.66f425e1.svg";